export default __webpack_public_path__ + "static/media/SINGH-BNB.888d4a88.png";